if (!customElements.get("product-price")) {
  class ProductPrice extends HTMLElement {
    constructor() {
      super();
      this.price = this.dataset.price;
      this.compareAtPrice = this.dataset.compareAtPrice;
      this.segmentDiscount = this.dataset.segmentDiscount * 1;

      this.productPriceSubscriptionPrice = this.querySelector(
        ".price-subscription-copy__price"
      );
      this.productPriceSubscriptionDiscount = this.querySelector(
        ".price-subscription-copy__discount"
      );
    }
    priceChangedUnsubscriber = undefined;
    connectedCallback() {
      // Update variantId if variant is switched on product page
      this.priceChangedUnsubscriber = subscribe(
        PUB_SUB_EVENTS.onPriceUpdate,
        (event) => {
          if (event.target !== this) return; // Ensure the event is for this specific element

          const priceElem = this.querySelector(".price");
          const compareAtPriceElem = this.querySelector(".compare-price");
          const priceContainer = this.querySelector(
            ".ps-offer__product-price-container"
          );

          // if  event.data.compareAtPrice is null, then it's a subscription
          // and no need to do any segment discount
          const finalPrice =
            this.segmentDiscount && event.data.isOnetime == true
              ? Math.ceil(
                  event.data.price -
                    (event.data.price * this.segmentDiscount) / 100
                )
              : event.data.price;
          const finalComparePrice =
            this.segmentDiscount && event.data.isOnetime == true
              ? event.data.price
              : event.data.compareAtPrice;

          if (priceContainer) {
            priceContainer.dataset.price = finalPrice;
          }

          priceElem.innerHTML = Shopify.formatMoney(finalPrice);

          if (compareAtPriceElem) {
            if (finalComparePrice > finalPrice) {
              priceElem.classList.add("on-sale");

              compareAtPriceElem.innerHTML =
                Shopify.formatMoney(finalComparePrice);
              compareAtPriceElem.style.display = "inline";
            } else {
              compareAtPriceElem.style.display = "none";
              priceElem.classList.remove("on-sale");
            }
          }

          if (this.querySelector(".discount") != null) {
            if (event.data.priceSuffix) {
              this.querySelector(
                ".discount"
              ).innerHTML = `(${event.data.priceSuffix})`;
            } else {
              this.querySelector(".discount").innerHTML = "";
            }
          }

          if (event.data.sellingPlanAllocation) {
            const discountPercentage =
              ((event.data.sellingPlanAllocation.compare_at_price -
                event.data.sellingPlanAllocation.price) *
                100) /
              event.data.sellingPlanAllocation.compare_at_price;

            if (this.querySelector(".price-subscription-copy__price") != null)
              this.querySelector(".price-subscription-copy__price").innerHTML =
                Shopify.formatMoney(
                  event.data.sellingPlanAllocation.price,
                  "${{amount}}"
                );

            if (
              this.querySelector(".price-subscription-copy__discount") != null
            )
              this.querySelector(
                ".price-subscription-copy__discount"
              ).innerHTML = `(${discountPercentage}% off)`;
          }
        }
      );
    }

    disconnectedCallback() {
      if (this.priceChangedUnsubscriber) {
        this.priceChangedUnsubscriber();
      }
    }
  }

  customElements.define("product-price", ProductPrice);
}
